import { Component, OnDestroy, OnInit } from '@angular/core';
import { WidgetsService } from '../../../../shared/services/widgets.service';
import { requestPayload, NewsItem } from '../../../../shared/models/model';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-news-widget',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './news-widget.component.html',
  styleUrl: './news-widget.component.scss',
})
export class NewsWidgetComponent implements OnInit, OnDestroy {
  newsData: NewsItem[] = [];
  errorMessage: string = '';
  newsSubscription: Subscription = new Subscription();
  constructor(
    private _widgetService: WidgetsService,
    private _router: Router,
  ) {}
  ngOnInit(): void {
    this.getNews();
  }
  //Fetching the news data
  getNews(): void {
    // payload for fetching news
    const payLoad: requestPayload = {
      requestingSystem: 'FinPro',
    };
    this.newsSubscription = this._widgetService.fetchNews(payLoad).subscribe(
      (data: any) => {
        let revisedData: NewsItem[] = [];
        if (data && data.newsList !== null && Array.isArray(data.newsList) && data.newsList.length > 0) {
          revisedData = data.newsList.map((element: NewsItem) => {
            element.revisedDate = element.publishedDate ? element.publishedDate.split('T')[0] : '';
            return element;
          });
          this.newsData = this.sortByDate(revisedData);
        }
      },
      //Error handling
      (error: string) => {
        this.errorMessage = error;
      },
    );
  }
  //Routing to news detail page
  gotoNewsDetail(event: MouseEvent, name: string, id: string) {
    event.preventDefault();
    this._widgetService.newsId = id;
    //routing to news detail page
    this._router.navigate([`/advisor/news/${name.replaceAll(' ', '-')}`], {
      state: { obj: id },
    });
  }

  // Helper method to encode the title
  encodeTitle(title: string): string {
    return encodeURIComponent(title.replace(/\s+/g, '-'));
  }

  // Helper method to encode the ID
  encodeId(id: string): string {
    return encodeURIComponent(id);
  }

  // Generate router link and query params for news
  generateNewsLink(news: NewsItem): { routerLink: string[]; queryParams: { id: string } } {
    return {
      routerLink: ['/advisor/news', this.encodeTitle(news.title)],
      queryParams: { id: this.encodeId(news.id) },
    };
  }

  //Routing to news list page
  gotoNewsList() {
    //routing to news list page
    this._router.navigateByUrl('/advisor/news');
  }
  //Sorting the news data by date
  sortByDate(data: NewsItem[] = []) {
    return data.sort((a: NewsItem, b: NewsItem) => {
      const dateA = new Date(a.revisedDate).getTime();
      const dateB = new Date(b.revisedDate).getTime();
      return dateB - dateA;
    });
  }
  ngOnDestroy(): void {
    this.newsSubscription.unsubscribe();
  }
}
